'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "Spinner": "Polaris-Spinner",
  "sizeSmall": "Polaris-Spinner--sizeSmall",
  "sizeLarge": "Polaris-Spinner--sizeLarge"
};

exports.default = styles;
